<div class="header">
    <div class="container">
        <div class="row">
            <div class="col-auto mt5">
                <div class="flmid">
                    <a href="javascript:void(0)" class="logo-brand" href="{{logoUrlLink}}" target="_blank" rel="noopener">
                        <img class="brand headerImage"  style="max-width: 100%;"  alt="Logo" /></a>
                </div>
            </div>
            <div class="col-auto mr-auto ml-3  ml-md-1 ml-lg-5 d-flex align-items-center">
                <nav aria-label="ml-5 pl-5">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="/dashboard" aria-label="home">
                                <em class="fas fa-home"></em>
                            </a>
                        </li>
                        <li class="breadcrumb-item active" *ngFor="let breadcrumb of breadcrumbs" aria-current="page" translate>{{breadcrumb.label}}</li>
                    </ol>
                </nav>
            </div>
            <div *ngIf="!isProd" class="d-flex align-items-center text-danger" translate>
              lblTestingEnvironment
            </div>
            <div class="col-auto ml-auto d-flex align-items-center" *ngIf="isUserStampInOutActive">
              <span class="mr-3" *ngIf="stampInTime !== ''"> {{ stampInTime }} </span>
              <button class="btn btn-sm btn-primary" *ngIf="stampInTime === ''" (click)="stampInOut(true)">Stamp In</button>
              <button class="btn btn-sm btn-primary" *ngIf="stampInTime !== ''" (click)="stampInOut()">Stamp Out</button>
            </div>
            <div class="col-auto d-flex align-items-center" *ngIf="isCdssUser && isPbxEnabled" [ngClass]="{'ml-auto': !isUserStampInOutActive}">
              <button type="button" class="align-self-center" (click)="DialCall(DialContent)" aria-label="Center Align">
                <em class="fa fa-phone-flip font22 align-middle"></em>
              </button>
              <button  type="button" class="align-self-center" (click)="OpenCallerPopup()" aria-label="Center Align" ngbTooltip="{{ 'lblShowCallerWindow' | translate }}" *ngIf="this.callerService.callerInfo">
                <em class="fa fa-clone font22 align-middle"></em>
              </button>
            </div>
            <div class="col-auto d-flex align-items-center" *ngIf="isWidgetAvailable">
              <a  class="align-self-center" ngbTooltip="Widget" href="{{WidgetLogoUrlLink}}" target="_blank" rel="noopener">
                <em class="icon-widget-car font-30 align-middle"></em>
              </a>
            </div>
            <div class="col-auto d-flex justify-content-end align-items-center">
              <div *ngIf="isShowNotification" class="mr-2 notification-box">

                <button
                  type="button"
                  class="align-self-center"
                  (click)="onNotificationClick()"
                  aria-label="Center Align"
                >
                  <em class="fa fa-bell font22 align-middle"></em>
                  <span
                    class="position-absolute translate-middle badge rounded-pill count"
                  >
                    {{ notificationCount }}
                  </span>
                </button>

                <div class="searchbox card fix lt" *ngIf="notificationPopupOpen">
                  <div class="padding-main bg-blue">
                    <div class="row mx-1 justify-content-between">
                      <div class="row align-items-center">
                        <em class="fa fa-bell font16 mr-1"></em>
                        <label class="mark-read mb-0" translate
                          >{{ notificationCount }} {{'lblUnreadNotification'|translate}}</label
                        >
                      </div>
                      <div>
                        <button (click)="markAllRead()" class="mark-read" translate>
                          lblMarkallasread
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="overflow-auto" style="max-height:225px">
                    <div *ngFor="let notification of notificationList; let i = index">
                      <div class="p-2 btm-border">
                        <div class="row mx-1 justify-content-between">
                          <div>
                            <p class="msg-header">{{ notification.subject }}</p>
                          </div>
                          <div>
                            <p class="msg-date">{{ notification.timeAgo }}</p>
                          </div>
                        </div>
                        <div class="mx-1">
                          <p class="msg-subject" [innerHTML]="notification.content"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row mx-1 justify-content-between align-items-center py-2"
                  >
                    <button (click)="onReadAll()" class="read-btn" translate>
                      lblReadallNotifications
                    </button>
                    <button
                      (click)="onNotificationClose()"
                      aria-label="Center Align"
                      class="btn btn-outline-tertiary mr-2"
                      translate
                    >
                      lblClose
                    </button>
                  </div>
                </div>
              </div>
              <div class="mr-24 whatsapp-notification-box" *ngIf = "isWhatsappFeatureActive">
                <button
                  type="button"
                  class="align-self-center position-relative"
                  (click)="onWhatsAppNotificationClick()"
                  aria-label="Center Align"
                >
                  <em class="fab fa-whatsapp font24 align-middle"></em>
                  <span
                    class="position-absolute translate-middle badge rounded-pill whatsapp-notification-count"
                  >
                    {{ whatsAppNotificationCount }}
                  </span>
                </button>
                
                <div class="searchbox card fix lt" *ngIf="whatsAppNotificationPopupOpen">
                  <ul class="list-group">
                    <li *ngIf="whatsAppNotificationCount>0"
                      class="list-group-item d-flex justify-content-between align-items-center bg-warning">
                      <label class="text-white"><em class="fab fa-whatsapp font16 mr-2 text-white"></em>{{whatsAppNotificationCount}} Unreplied WhatsApp message(s)</label>
                    </li>
                    <ng-container *ngIf="unrepliedWhatsAppMessages?.length>0; else unrepliedWhatsAppMessages_empty">
                      <li class="list-group-item scrollable-container" [perfectScrollbar]
                        *ngFor="let unrepliedMessage of unrepliedWhatsAppMessages">
                        <a>
                            <h6 class="d-flex justify-content-between mb-1">
                              <span class="text-bold fs-14px">{{unrepliedMessage.customerName}}</span>
                              <small class="lighten-1 float-right text-danger">
                                {{unrepliedMessage.delayInReply}}<i class="fa fa-hourglass-half ml-1 "></i>
                              </small>
                            </h6>
                            <small class="text-muted">{{unrepliedMessage.whatsAppMessage}}</small>
                        </a>
                      </li>
                
                    </ng-container>
                    <ng-template #unrepliedWhatsAppMessages_empty>
                      <li class="list-group-item scrollable-container" [perfectScrollbar]>
                        <a class="d-flex justify-content-between">
                          <div class="media d-flex align-items-center">
                            <div class="media-body">
                              <h6 class="m-0" translate>
                                lblNoNotification
                              </h6>
                            </div>
                          </div>
                        </a>
                      </li>
                
                    </ng-template>
                    <li class="list-group-item text-center">
                      <a class="text-info fs-14px py-1"
                        (click)="viewAllUnrepliedWhatsAppMessages()">View All Unreplied Messages</a>
                    </li>
                  </ul>
                </div>
              </div>
                <div class="lang-dropdown mr-4" *ngIf="isLanguageDropDown">
                    <ng-select [items]="languages" bindLabel="Value" bindValue="key" placeholder="Select Language" (change)="ChangeLanguage($event.key)" [(ngModel)]="currentLang" [clearable]="false" [searchable]="false">

                        <ng-template ng-label-tmp let-item="item">
                            <img height="15" width="20" alt="{{item.value}}" [src]="getFlagImage(item.flagName)" onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <img height="15" width="20" alt="{{item.value}}" [src]="getFlagImage(item.flagName)" onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>

                    </ng-select>
                </div>
                <div class="user-info">
                    <div class="d-flex">
                        <p class="mt-0 mr-3">
                            <span><strong class="fs-15px clrthemegrey">{{currentSignedInUser}}</strong></span>
                            <span class="fs-14px d-block mt-1">{{currentUserRole}}</span>
                        </p>
                        <div class="d-flex align-items-center cursor mr-2" (click)="onLogout()">
                          <em class="fa fa-power-off font22"></em>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<app-menu></app-menu>
<!-- Click to dial number popup -->
<ng-template #DialContent let-modal>
  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" translate>lblCall</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)"><span aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
      <form class="form" #dialForm="ngForm" class="row">
        <div class="col-12 af-form-group">
          <input class="form-control" name="dialNumber" (keyup.enter)="InitiateCall(modal)" [(ngModel)]="dialNumber" placeholder="{{ 'lblDestinationNumber' | translate }}" required />
          <div *ngIf="(dialForm.touched || dialForm.submitted) && !dialForm.form.valid" class="help-block text-danger">
            <em class="fa fa-exclamation-circle" aria-hidden="true"></em>
            <span translate>lblDestinationNoRequired</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary mr-sm-2 btn-md" (click)="InitiateCall(modal)" translate>lblCall</button>
      <button type="button" class="btn btn-secondary btn-md" (click)="modal.dismiss(false)" translate>lblCancel</button>
    </div>
</ng-template>